module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "pl-3-3"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copytop"
  }, [_vm._v("Text and artwork ©2003 Ricky Tims")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITOR")]), _vm._v("-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IN")]), _vm._v("-C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIEF")]), _vm._v(": "), _c('i', [_vm._v("Dana Williamson")])]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITOR")]), _vm._v(": "), _c('i', [_vm._v("Cyndy Lyle Rymer")])]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECHNICAL")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITOR")]), _vm._v(": "), _c('i', [_vm._v("Sara Kate MacFarland")])]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPY")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITOR")]), _vm._v("/P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROOFREADER")]), _vm._v(": "), _c('i', [_vm._v("Lee Jonsson/Joyce E. Lytle/Eva Simoni Er")]), _vm._v("b")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVER")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESIGNER")]), _vm._v(": "), _c('i', [_vm._v("Christina farumay")])]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESIGN")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRECTOR")]), _vm._v("/B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOK")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESIGNER")]), _vm._v(": "), _c('i', [_vm._v("Rose Shelter")])]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LLUSTRATOR")]), _vm._v(": "), _c('i', [_vm._v("Kirstie L. McCormick")])]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RODUCTION")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SSISTANT")]), _vm._v(": "), _c('i', [_vm._v("Jetfery Carrillo")])]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOTOGRAPHY")]), _vm._v(": Quilt photography by John Bonath, Maddog Studio, Denver, CO; Digital photos by Ricky Tims and Justin Shults unless otherwise noted")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Published by C&T Publishing, Inc., P.O. Box 1456, Lafayette, California, 94549")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4775de99","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/0003_copyright-title.vue
// module id = 60
// module chunks = 0